// extracted by mini-css-extract-plugin
export default {"categoryChips":"CategoryChips_categoryChips__SUloM","chipsContainer":"CategoryChips_chipsContainer__UJwFV","chip":"CategoryChips_chip__m0srU","active":"CategoryChips_active__vY1cW"};